import {twJoin} from 'tailwind-merge'

export const FeedSkeleton = () => (
  <div className={'flex h-screen w-full flex-col bg-surface-primary md:w-sidebar'}>
    <div className={'flex flex-col gap-spacing-32 px-spacing-24 pb-spacing-16 pt-spacing-32'}>
      {/*  logo + welcome message */}
      <div className={'flex flex-col'}>
        <div className={'h-spacing-44 max-w-[66%] bg-gray-300'}></div>
        <div className={'my-spacing-8 h-px bg-outline-secondary'}></div>
        <div className={'h-spacing-20 w-spacing-128 animate-pulse bg-gray-300 pt-spacing-4'}></div>
      </div>
      <div className={'flex flex-col gap-spacing-6'}>
        <div className={'h-spacing-24 w-spacing-128 animate-pulse bg-gray-300'}></div>
        <div className={'h-spacing-24 w-[222px] animate-pulse bg-gray-300'}></div>
      </div>
    </div>
    {/*  contact + share */}
    <div className={'flex w-full items-center justify-between self-stretch p-spacing-16 md:px-spacing-24'}>
      <div className={'flex flex-1 items-center gap-spacing-12'}>
        <div className={'size-spacing-56 bg-gray-300'}></div>
        <div className={'flex flex-col items-start gap-spacing-2'}>
          <div className={'h-spacing-14 w-spacing-80 animate-pulse bg-gray-300'}></div>
          <div className={'h-spacing-14 w-spacing-128 animate-pulse bg-gray-300'}></div>
        </div>
      </div>
      <div className={'flex size-spacing-64 items-center justify-center'}>
        <div className={'size-spacing-24 bg-gray-300'}></div>
      </div>
    </div>
    {/*  feed items */}
    <div className={'flex animate-pulse-slow flex-col gap-spacing-32 overflow-auto py-spacing-16 md:pb-spacing-80'}>
      <div
        className={twJoin(
          'grid grid-cols-1 gap-spacing-12 px-spacing-16',
          'sm:grid-cols-2 sm:gap-spacing-12',
          'md:grid-cols-1 md:gap-spacing-12 md:px-spacing-32',
        )}
      >
        <div className={'relative rounded-radius-lg bg-interactive-surface-filled-tile-default'}>
          <div className={'absolute inset-y-1/2 -left-spacing-16 hidden w-spacing-8 items-center md:flex'}>
            <div
              className={twJoin(
                'h-spacing-80 w-spacing-8 rounded-full',
                'block bg-gray-300',
              )}
            />
          </div>
          <div className={'aspect-[16/10] w-full rounded-t-radius-lg bg-gray-300'}/>
          <div className={'flex flex-col gap-spacing-8 p-spacing-16'}>
            <div className={'h-spacing-16 w-2/3 bg-gray-300'}/>
            <div className={'h-spacing-16 w-1/3 bg-gray-300'}/>
          </div>
        </div>
        <div className={'overflow-hidden rounded-radius-lg bg-interactive-surface-filled-tile-default'}>
          <div className={'aspect-[16/10] w-full bg-gray-300'}/>
          <div className={'flex flex-col gap-spacing-8 p-spacing-16'}>
            <div className={'h-spacing-16 w-2/3 bg-gray-300'}/>
            <div className={'h-spacing-16 w-1/3 bg-gray-300'}/>
          </div>
        </div>
        <div className={'overflow-hidden rounded-radius-lg bg-interactive-surface-filled-tile-default'}>
          <div className={'aspect-[16/10] w-full bg-gray-300'}/>
          <div className={'flex flex-col gap-spacing-8 p-spacing-16'}>
            <div className={'h-spacing-16 w-2/3 bg-gray-300'}/>
            <div className={'h-spacing-16 w-1/3 bg-gray-300'}/>
          </div>
        </div>
      </div>
    </div>
  </div>
)
